import * as events from "../events/library/libraryEvents";
import { type IMapping } from "./types";
import { type MidnightActionPayload, type Dispatcher } from "../../../../../interfaces/redux";
import { createDispatcher } from "../dispatcher";
import {
  createDraftSuccess,
  publishSuccess,
  revertSuccess,
  successAction,
  updateSuccess,
} from "features/Library/SimulatedPhishing/Campaigns/state/slices/campaignEntityStateSlice";
import { AlertTypes } from "enums";
import {
  updateFailedTaskDistributedOperation,
  updateProgressTaskDistributedOperation,
  updateSucceededTaskDistributedOperation,
} from "features/BackgroundTasks/state/backgroundTasksActions";

export const campaignMapping = (mapping: IMapping, dispatcher: Dispatcher) => {
  const { dispatch, dispatchPublishSuccess, dispatchMap, dispatchAlert } = createDispatcher(dispatcher);

  mapping[events.CampaignEditV2Success] = dispatchMap<{ id: number }, MidnightActionPayload>(
    updateSuccess,
    (message) => ({ entityId: message.id }),
  );
  mapping[events.CampaignEmailTemplateEditSuccess] = dispatchMap<{ id: number }, MidnightActionPayload>(
    updateSuccess,
    (message) => ({ entityId: message.id }),
  );
  mapping[events.CampaignFeedbackPageEditSuccess] = dispatchMap<{ id: number }, MidnightActionPayload>(
    updateSuccess,
    (message) => ({ entityId: message.id }),
  );
  mapping[events.CampaignV2UpdateCommandCompleted] = dispatch(successAction);

  mapping[events.CampaignPublishV2Success] = dispatchPublishSuccess<{ id: number; name: string }>(
    publishSuccess,
    (data) => `${data.name} was published.`,
  );

  mapping[events.CampaignLockV2Success] = dispatchMap<{ id: number }, MidnightActionPayload>(
    createDraftSuccess,
    (message) => ({ entityId: message.id }),
  );

  mapping[events.CampaignDiscardV2Success] = dispatch(revertSuccess);

  mapping[events.CampaignDuplicateSuccess] = (payload) =>
    dispatcher(updateProgressTaskDistributedOperation(payload.operationId, payload.stepId));

  mapping[events.CampaignDuplicateAllSuccess] = (payload) =>
    dispatcher(updateSucceededTaskDistributedOperation(payload.operationId));

  mapping[events.CampaignDuplicateAllFailure] = (payload) =>
    dispatcher(updateFailedTaskDistributedOperation(payload.operationId));

  mapping[events.CampaignDuplicateFailure] = (payload) =>
    dispatcher(updateFailedTaskDistributedOperation(payload.operationId));

  mapping[events.CampaignDeleteSuccess] = (payload) =>
    dispatcher(updateProgressTaskDistributedOperation(payload.operationId, payload.stepId));

  mapping[events.CampaignDeleteAllSuccess] = (payload) =>
    dispatcher(updateSucceededTaskDistributedOperation(payload.operationId));

  mapping[events.CampaignDeleteAllFailure] = (payload) =>
    dispatcher(updateFailedTaskDistributedOperation(payload.operationId));

  mapping[events.CampaignDeleteFailure] = (payload) =>
    dispatcher(updateFailedTaskDistributedOperation(payload.operationId));

  mapping[events.CampaignRunV2CreateSuccess] = (payload) =>
    dispatcher(updateProgressTaskDistributedOperation(payload.operationId, payload.stepId));

  mapping[events.CampaignRunV2CreateAllSuccess] = (payload) =>
    dispatcher(updateSucceededTaskDistributedOperation(payload.operationId));

  mapping[events.CampaignRunV2CreateFailure] = (payload) =>
    dispatcher(updateFailedTaskDistributedOperation(payload.operationId));

  mapping[events.CampaignRunV2CreateAllFailure] = (payload) =>
    dispatcher(updateFailedTaskDistributedOperation(payload.operationId));

  mapping[events.CampaignRunForTemplateCreateSuccess] = (payload) =>
    dispatcher(updateProgressTaskDistributedOperation(payload.operationId, payload.stepId));

  mapping[events.CampaignRunForTemplateCreateAllSuccess] = (payload) =>
    dispatcher(updateSucceededTaskDistributedOperation(payload.operationId));

  mapping[events.CampaignRunForTemplateCreateFailure] = (payload) =>
    dispatcher(updateFailedTaskDistributedOperation(payload.operationId));

  mapping[events.CampaignRunForTemplateCreateAllFailure] = (payload) =>
    dispatcher(updateFailedTaskDistributedOperation(payload.operationId));

  mapping[events.CampaignRunCompletedSuccess] = dispatchAlert(AlertTypes.success, "Send was successfully completed!");

  mapping[events.CampaignRunCanceledSuccess] = dispatchAlert(AlertTypes.success, "Send was successfully canceled!");
};
